import '../../scripts/common';

import 'animate.css/animate.css';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Radio from '../../components/base/Radio';
import Rating from '../../components/base/Rating';
import Spinner from '../../components/base/Spinner';
import Select from '../../components/base/Select';
import Breadcrumbs from '../../components/base/Breadcrumbs';
import Popup from '../../components/base/Popup';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import ProductFeatures from '../../components/simple/ProductFeatures';
import MessageCard from '../../components/MessageCard';
import Nameplate from '../../components/simple/Nameplate';
import RubleCircle from '../../components/simple/RubleCircle';

import initProductCarousel from './productCarousel';
import initAdvicesCarousel from './advicesCarousel';
import initInfoCardsCarousel from './infoCardsCarousel';
import initReviews from './reviews';
import initReviewsCarousel from './reviewsCarousel';
import initProductPictureFullLink from './pictureFullscreenCarousel';
import initReviewImage from './reviewImage';
import initRecommendationsCarousel from './recommendationsCarousel';
import initOrderBlock from './orderBlock';
import { initChangeVariantsHandler } from '../../scripts/backend/common-catalog';

import './styles.css';
import '../../styles/product-outlet.css';

import '../../images/sprite/cart.svg';
import '../../images/sprite/list.svg';
import '../../images/sprite/safety.svg';
import '../../images/sprite/delivery_lg.svg';
import '../../images/sprite/arrow_xl.svg';
import '../../images/sprite/youtube.svg';
import '../../images/sprite/arrow_down.svg';
import '../../images/sprite/like.svg';
import '../../images/sprite/dislike.svg';
import '../../images/sprite/check_2.svg';
import '../../images/responsive/user.png';

$(() => {
    Header.create();
    Footer.create();
    Breadcrumbs.create();
    PageScrollBtn.create();
    Radio.create();
    initPopup();
    initRating();
    initSpinner();
    initProductCarousel($('.js-product-carousel-wrapper.selected'));
    initAdvicesCarousel();
    initReviewsCarousel();
    initReviews();
    initProductPictureFullLink();
    initRecommendationsCarousel();
    initOrderBlock();
    ProductFeatures.create();
    RubleCircle.create();
    Nameplate.create();
    initMessageCard();
    initInfoCardsCarousel();
    initReviewImage();
    initSelect();
    initProductVariants();
});

/**
 * Инициализация селекта
 */
function initSelect() {
    const selectSort = new Select($('.select--feedbacks-sort'));

    selectSort.init({
        isSearch: false,
    });
}

/**
 * Инициализация торговых предложений
 */
function initProductVariants() {
    initChangeVariantsHandler($('.js-product-info-wrapper'));
}

/**
 * Инициализация рейтинга
 */
function initRating() {
    const productRating = new Rating($('.js-product-page-rating'));
    const reviewsRating = new Rating($('.js-product-page-reviews-rating'));

    productRating.init();
    reviewsRating.init();

    $('.js-product-feedback-rating').each((i, item) => {
        const feedbackRating = new Rating($(item));

        feedbackRating.init();
    });
}

/**
 * Инициализация счетчика
 */
function initSpinner() {
    const productSpinner = new Spinner($('.js-product-page-spinner'));

    productSpinner.init();
}

/**
 * Активация попапов
 */
function initPopup() {
    $('.popup--product-pic-fullscreen').each(function() {
        const popupProductFullPic = new Popup($(this));
        popupProductFullPic.init({
            animationTime: 300,
        });
    });

    const popupQuickView = new Popup($('#popup-quick-view'));
    popupQuickView.init();

    if ($('#popup-product-certificates').length) {
        const popupCertificates = new Popup($('#popup-product-certificates'));
        popupCertificates.init();
    }
}

/**
 * Инициализация карточек сообщений
 */
function initMessageCard() {
    $('.message-card').each((i, item) => {
        const messageCard = new MessageCard($(item));
        messageCard.init({});
    });
}

function checkMessageHeight() {
    const $wrappers = $('.js-product-feedback-wrapper');

    $wrappers.each((i, elem) => {
        const message = $(elem).find('.js-product-feedback')[0];
        const $btn = $(elem).find('.js-product-feedback-show-more');

        const hasOverflow = message.scrollHeight > message.clientHeight || message.scrollWidth > message.clientWidth;

        if (hasOverflow) {
            $btn.removeClass('is-invisible');
        } else {
            $btn.addClass('is-invisible');
        }
    });
}

checkMessageHeight();

/**
 * Обновление всех параметров при ресайзе
 */
let timerId;
$(window).on('resize', () => {
    clearTimeout(timerId);

    timerId = setTimeout(() => {
        checkMessageHeight();
    }, 200);
});

/**
 * Фикс картинок в IE
 * (вертикальная карусель не может корректно отрисовать картинки)
 */
$(window).on('load', () => {
    const $pictures = $('.carousel--product-thumbnails .picture__img');
    $pictures.css('display', 'block');

    setTimeout(() => {
        $pictures.css('display', '');
    }, 200);
});

/**
 * Скрытие/раскрытие отзыва о товаре
 */
$(document).on('click', '.js-product-feedback-show-more', ({ currentTarget }) => {
    const $button = $(currentTarget);
    const $message = $button.closest('.js-product-feedback-wrapper').find('.js-product-feedback');

    if ($message.hasClass('is-visible')) {
        $message.removeClass('is-visible');
        $button.removeClass('is-active');
    } else {
        $message.addClass('is-visible');
        $button.addClass('is-active');
    }
});
